document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector(".collection-seo--link");
    button.addEventListener("click", (evt) => {
        if (evt.target.closest(".collection-seo")) {
            evt.target.closest(".collection-seo").classList.toggle("collection-seo--ellipsis");
        }
    })
});